import React from 'react';

const HeroBanner = ({
  heroImage,
  isEditingHero,
  setIsEditingHero,
  heroFile,
  setHeroFile,
  uploading,
  handleHeroImageChange,
  handleHeroUpload,
  fileInputRef,
  triggerFileInput
}) => {
  return (
    <div 
      className="cover-banner" 
      style={{ 
        backgroundImage: `url(${heroImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Hidden file input for future references */}
      <input 
        type="file" 
        onChange={handleHeroImageChange} 
        accept="image/*"
        ref={fileInputRef}
        style={{ display: 'none' }}
      />
    </div>
  );
};


export default HeroBanner;